import { Modal, Radio, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { aiModelSelector } from 'views/Orgs/selector';
import { actions } from 'views/Orgs/redux';

const ChooseAIModelModal = (props) => {
  const { setShowAIModelModal } = props;
  const dispatch = useDispatch();

  // set value from selector on mount
  const aiModel = useSelector(aiModelSelector());
  console.log("aiModel ======>", aiModel);
  const [value, setValue] = useState(aiModel);
  const saveInRedux = (value) => {
    // dispatch({ type: "SET_AI_MODEL", payload: model });
    // close in success callback
    // show success message
    console.log("actions ======>", actions);
    dispatch(actions.setAiModelSuccess(value))
    setShowAIModelModal(false)
  }

  return <Modal
    visible={true}
    title="Choose AI Model"
    width="600px"
    closable={true}
    onCancel={() => setShowAIModelModal(false)}
    onOk={() => saveInRedux(value)}
    okText="Save"
  >
    <Space direction="vertical">
      <i>[Defaults: GPT3.5-turbo for chat, GPT4 for everything else]</i>
      <i>[Note: Claude models can only be used for generate Qs and grading. Selecting Claude here will have no effect if checking Chat or Explanation or Writing assistant]</i>
      <Radio.Group className='m-t-10 m-b-10' onChange={(e) => setValue(e.target.value)} value={value} buttonStyle={"solid"} optionType={"button"}>
        <Radio value={"GPT3.5"}>GPT3.5</Radio>
        <Radio value={"GPT4"}>GPT4</Radio>
        <Radio value={"GPT4-turbo"}>GPT4-turbo</Radio>
        <Radio value={"Claude3-haiku"}>Claude3-haiku</Radio>
        <Radio value={"Claude3-sonnet"}>Claude3-sonnet</Radio>
        <Radio value={"Claude3-opus"}>Claude3-opus</Radio>
      </Radio.Group>
    </Space>
  </Modal>
}

export default ChooseAIModelModal;
